import { t } from 'i18next';
import * as React from 'react';
import { languageSwitch } from './languageSwitch';

export const header = ({ menuOpen, isProductActive }: { menuOpen?: boolean; isProductActive?: boolean }) => {
  return (
    <div className={menuOpen ? 'nav--toggled' : 'nav--hidden'}>
      <a href="#a11y-main" className="sr-text">
        {t('Header:A11y.SkipToContent')}
      </a>
      <a href="#a11y-footer" className="sr-text">
        {t('Header:A11y.SkipToFooter')}
      </a>
      <header className="header">
        {languageSwitch(false)}
        <div className="header__inner container container--m grid--gutter">
          <a className="header__logo" href="#">
            <span className="sr-text">returnToHome</span>
            <img src="/images/logo-new-refresco.svg" alt="" />
          </a>
          <nav className="header__nav nav nav--main nav--mobile" id="a11y-main-menu-collapse" aria-hidden="true">
            <ul className="nav__list nav__list--primary">
              <li className="nav__item">
                <a className="nav__link" href="/focus-areas">
                  What we do
                </a>
                <button className="nav__button"></button>
                <ul className="sublist sublist--hidden">
                  <li className="sublist__item">
                    <a className="sublist__link" href="/focus-areas">
                      Nibh Condimentum Venenatis
                    </a>
                  </li>
                  <li className="sublist__item">
                    <a className="sublist__link" href="/focus-areas">
                      Commodo Risus Sem Sollicitudin
                    </a>
                  </li>
                  <li className="sublist__item">
                    <a className="sublist__link" href="/focus-areas">
                      Aenean Fringilla Etiam
                    </a>
                  </li>
                  <li className="sublist__item">
                    <a className="sublist__link" href="/focus-areas">
                      Commodo Elit
                    </a>
                  </li>
                </ul>
              </li>
              <li className="nav__item">
                <a className={`nav__link nav__link--active has-children`} href="/products">
                  Products
                </a>
                <button className="nav__button nav__button--toggled"></button>
                <ul className="sublist sublist--shown">
                  <li className="sublist__item">
                    <a className="sublist__link" href="/focus-areas">
                      What we do
                    </a>
                  </li>
                  <li className="sublist__item">
                    <a className="sublist__link" href="/focus-areas">
                      Commodo Risus Sem Sollicitudin
                    </a>
                  </li>
                  <li className="sublist__item">
                    <a className="sublist__link" href="/focus-areas">
                      Aenean Fringilla Etiam
                    </a>
                  </li>
                  <li className="sublist__item">
                    <a className="sublist__link" href="/focus-areas">
                      Commodo Elit
                    </a>
                  </li>
                </ul>
              </li>
              <li className="nav__item">
                <a className={`nav__link${isProductActive == true ? ' nav__link--active' : '' }`} href="/products">
                  Products
                </a>
              </li>
              <li className="nav__item">
                <a className="nav__link" href="/inspiration">
                  Inspiration
                </a>
              </li>
              <li className="nav__item">
                <a className="nav__link" href="/service">
                  Service
                </a>
              </li>
              <li className="nav__item">
                <a className="nav__link" href="/about-us">
                  About us
                </a>
              </li>
              <li className="nav__item nav__item--contact">
                <a className="nav__link" href="/contact">
                  Contact
                </a>
              </li>
            </ul>
          </nav>

          <nav className="header__nav nav nav--main nav--desktop" id="a11y-main-menu-collapse" aria-hidden="true">
            <ul className="nav__list nav__list--primary">
              <li className="nav__item">
                <a className="nav__link" href="/focus-areas">
                  What we do
                </a>
              </li>
              <li className="nav__item">
                <a className={`nav__link nav__link--active has-children`} href="/products">
                  Products
                </a>
              </li>
              <li className="nav__item">
                <a className={`nav__link${isProductActive == true ? ' nav__link--active' : '' }`} href="/products">
                  Products
                </a>
              </li>
              <li className="nav__item">
                <a className="nav__link" href="/inspiration">
                  Inspiration
                </a>
              </li>
              <li className="nav__item">
                <a className="nav__link" href="/service">
                  Service
                </a>
              </li>
              <li className="nav__item">
                <a className="nav__link" href="/about-us">
                  About us
                </a>
              </li>
            </ul>
          </nav>
          
          <div className="header__actions">
            <a className="header__contact" href="/contact">
              Contact
            </a>

            <button className="header__lang">
              <svg className="header__lang-icon" height="22" width="22">
                <use xlinkHref="#icon--lang" />
              </svg>
              <span className="sr-text">international</span>
            </button>

            <button className="header__toggler" aria-controls="a11y-main-menu-collapse" aria-expanded="false">
              <span className="sr-text">menu.open</span>
              <span aria-hidden="true" />
              <span aria-hidden="true" />
              <span aria-hidden="true" />
            </button>

            <button className="header__search" aria-controls="a11y-search-collapse" aria-expanded="false">
              <span className="sr-text">search.open</span>
              <svg className="header__search-icon" height="22" width="22">
                <use xlinkHref="#icon--search" />
              </svg>
            </button>
          </div>
        </div>
      </header>
    </div>
  )
}
